<template>
  <div>
    <slotBase
      bgGrey
      fixedFooter
    >
      <template v-slot:content>
        <div
          class="main p-a-16"
          style="display: flex; align-items: center; height: 90vh"
        >
          <card />
        </div>
      </template>
      <template v-slot:footer>
        <div class="p-x-24 p-t-16 p-b-16">
          <div class="btn-container my-2">
            <button
              type="button"
              class="btn btn-outline-primary w-100 f-Overpass"
              style="font-size: 16px"
              @click="daftar"
            >
              Daftar
            </button>
            <button
              type="button"
              class="btn btn-primary w-100 f-Overpass p-t-8"
              style="font-size: 16px; margin-top: 8px"
              @click="masuk"
            >
              Masuk
            </button>
          </div>
        </div>
      </template>
    </slotBase>
  </div>
</template>
<script>
import slotBase from "@/components/slots/slotBase.vue";
import card from "../components/card.vue";

export default {
  name: "loginApp",
  components: {
    slotBase,
    card,
  },
  methods: {
    daftar() {
      this.$router.push({ name: "Register" });
    },
    masuk() {
      this.$router.push({ name: "login" });
    },
  },
};
</script>
